
import React, { useEffect, useState } from 'react'
import HoverImage from 'react-hover-image/build';
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import Calendar from 'assets/icon/calendar-icon.svg';
import { Field, Formik } from 'formik';
import reset from 'assets/icon/reset.svg';
import search from 'assets/icon/search.svg';
import moment from 'moment';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import useContextService from 'hooks/useContextService';
import useAxios from 'hooks/useAxios';
import ReactInputMask from 'react-input-mask';
import DatePicker from "react-datepicker";

let hasDatePopupOpen = false;

let rowForEdit = {};
let updatedFields = {};

const SearchContainer = (props) => {
    const {
        // manval,
        // manvalConfigedit,
        // manvalConfig,
        onSearchReports,
        onReset,
        setFilterShow,
        selectedcoveredEntity,
        reportStartPage,
        setSelectedValues,
        setReportStartPage,
        setSort, 
        application,
    } = props;
    const {
        states: { reports },
        setStates,
        resetStates,
    } = useContextService();
    const { SearchTerms, } = reports;

    const API = useAxios();

    const [data, setData] = useState([]);
    const [showDetails, setShowDetails] = useState(true)
    const [startDateValue, setStartdate] = useState(null);
    const [endDateValue, setEndDate] = useState(null);
    const [ceid, setceid] = useState()
    const [appid, setAppid] = useState("")
    // const [application, setApplication] = useState([])
    const [reportType, setReportType] = useState([])
    const [reportid, setReportid] = useState()
    const [endDateError, setEndDateError] = useState(false)
    const [error, setError] = useState(false)
    const [focusedInput, setFocusedInput] = useState('');
    const [coveredEntityData, setCoveredEntityData] = useState([])
    const updateStates = (reports) => {
        setStates('reports', reports);
    };

    const fetchCoveredEntities = async (id) => {
        let ApiURL = ''
        // if (id == application[0]?.encryptedAppId) {
        //     ApiURL = 'api/CP/configured'
        // }
        // if (id == application[1]?.encryptedAppId) {
        //     ApiURL = 'api/CP2/configured'
        // }
        ApiURL = `api/ReportConfig/configured/${id}`
        try {
            const { data } = await API.get(ApiURL
                , {
                    hasDefaultURL: true,
                }
            );
            if (data) {
                setCoveredEntityData(data)
            }
        } catch (error) {
            'failed to load data'
        }
    };

    useEffect(() => {
        if (appid) {
            fetchCoveredEntities(appid);
        }
    }, [selectedcoveredEntity])

    useEffect(() => {
    }, [showDetails])

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handleStartDate = (startDate) => {
        if (startDate !== null) {
            const date = moment(startDate, 'MM/DD/YYYY', true);
            if (date.isValid()) {
                setStartdate(date.toDate());
            }
        }
        else {
            setStartdate(null);
        }
    };

    const handleStartDateRaw = (e) => {
        var val = e.target.value;
        if (val == '__/__/____' && startDateValue !== null) {
            setStartdate(null);
            setError(false)
            //SearchTerms.startDate = null;
        }
        if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
            handleStartDate(e.target.value);
            //SearchTerms.startDate = val;
        }
    }

    const handleEndDate = (endDate) => {
        if (endDate !== null) {
            const date = moment(endDate, 'MM/DD/YYYY', true);
            if (date.isValid()) {
                setEndDate(date.toDate());
                //SearchTerms.endDate= endDate
            }
        } else {
            setEndDate(null);
            setEndDateError(false)
            //SearchTerms.endDate=null
        }
    };

    const handleEndDateRaw = (e) => {
        var val = e.target.value;
        if (val == '__/__/____' && endDateValue !== null) {
            setEndDate(null);
            setEndDateError(false)
            // SearchTerms.endDate=null
        }
        if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
            handleEndDate(e.target.value);
            //  SearchTerms.endDate=val
        }
    }

    const handleFocus = (inputName) => {
        setFocusedInput(inputName);
    };

    const handleBlur = () => {
        setFocusedInput('');
    };

    const handleAppChange = (e) => {
        const { value } = e.target;
        setceid('')
        setCoveredEntityData([])
        setReportType([])
        setReportid('')
        setAppid(value)
        if (value) {
            fetchCoveredEntities(value)
            fetchReportType(value)
        }
        else {
            setReportType([])
        }
    }

    const fetchReportType = async (applicationId) => {
        try {
            const { data } = await API.get(`api/Report/types/${applicationId}`
                , {
                    hasDefaultURL: true,
                }
            );
            setReportType(data)
        } catch (error) {
            'failed to load data'
            setReportType([])
        }
    };

    const handleReportChange = (e) => {
        const { value } = e.target;
        setReportid(value);
    }

    const handleCeChange = (e) => {
        const { value } = e.target;
        setceid(value);
        //SearchTerms.coveredEntityIDs = value;
    };

    const handleSubmit = async () => {
        let values = {};
        // values.ApplicationId = appid,
        values.coveredEntityID = ceid,
            values.ReportTypeId = reportid
        values.StartDate = startDateValue
        values.EndDate = endDateValue
        SearchTerms.coveredEntityIDs = ceid
        SearchTerms.ApplicationId = appid
        SearchTerms.ReportTypeId = reportid
        SearchTerms.startDate = startDateValue
        SearchTerms.endDate = endDateValue
        reports.Search.currentPage = 1;
        reports.Search.order = 'desc'
        updateStates(reports);
        if (appid == '' || appid == undefined || ceid == '' || ceid == undefined || (endDateValue !== null && endDateValue < startDateValue)) {
            setError(true)
            if (endDateValue !== null && endDateValue < startDateValue) {
                setEndDateError(true);
            }
            else {
                setEndDateError(false);
            }
        }
        else {
            setError(false)
            await onSearchReports(values);
        }
        setFilterShow(false)
        setReportStartPage(2)
        setSelectedValues('')
        setSort(false)
    };

    const handleReset = () => {
        setAppid("")
        setceid("");
        setReportid("");
        setReportType([])
        setEndDate(null);
        setStartdate("")
        setError(false);
        onReset();
        setSelectedValues('')
        updateStates(reports);
        resetStates('reports');
    };

    return (
        <div>
            <Formik
                initialValues={SearchTerms}
                onSubmit={handleSubmit}
                onReset={handleReset}
                // validationSchema={validationSchema}
                enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                        <div>
                            <div >
                                <Row className='d-flex' style={{}}>
                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup className='controls'>
                                            <Label
                                                htmlFor="Application" for='reportname'
                                                className={focusedInput === 'Application' ? 'label-focus' : 'required'}
                                            >Application <span>*</span></Label>
                                            <Field
                                                id='reportname'
                                                name='reportname'
                                                className="required"
                                                type='select'
                                                placeholder="(All)"
                                                autoComplete='off'
                                                value={appid}
                                                //disabled
                                                onChange={(e) => handleAppChange(e)}
                                                component={FormikSelectField}
                                                options={application}
                                                defaultoption="--select--"
                                                keys={{
                                                    id: 'encryptedAppId',
                                                    label: 'applicationType',
                                                }}
                                                onFocus={() => handleFocus('Application')}
                                                onBlur={handleBlur}
                                            >
                                            </Field>
                                            {(error) && (appid == '' || appid === undefined) && <div className="text-danger f-12">
                                                Application Type is required </div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} lg={3} sm={6} xs={6}>
                                        {' '}
                                        <FormGroup>
                                            <Label for='coveredentity'></Label>
                                            <Label
                                                htmlFor="CoveredEntity" for='reportname'
                                                className={focusedInput === 'CoveredEntity' ? 'label-focus' : 'required'}
                                            >Covered Entity /OPAID <span>*</span></Label>
                                            <Field
                                                className="required"
                                                name='covereEntity'
                                                type='text'
                                                disabled={appid == ""}
                                                value={ceid}
                                                onChange={(e) => handleCeChange(e)}
                                                component={FormikSelectField}
                                                options={coveredEntityData}
                                                onFocus={() => handleFocus('CoveredEntity')}
                                                onBlur={handleBlur}
                                                defaultoption='--select--'
                                                keys={
                                                    // appid ==  application?.[0]?.encryptedAppId ? 
                                                    {
                                                //     id: 'ceid',
                                                //     label: 'ceName',
                                                // } : {
                                                    id: 'encryptedCEID',
                                                    label: 'coveredEntityName',
                                                }}
                                            />
                                            {(error) && (ceid == '' || ceid === undefined) && <div className="text-danger f-12">
                                                Covered Entity name is required</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup>
                                            <Label
                                                htmlFor="ReportType" for='reportname'
                                                className={focusedInput === 'ReportType' ? 'label-focus' : ''}
                                            >Report Type</Label>
                                            <Field
                                                name='ReportType'
                                                type='text'
                                                value={reportid}
                                                disabled={appid == ""}
                                                onChange={handleReportChange}
                                                component={FormikSelectField}
                                                options={reportType}
                                                onFocus={() => handleFocus('ReportType')}
                                                onBlur={handleBlur}
                                                defaultoption='--select--'
                                                keys={{
                                                    id: 'encryptedReportTypeID',
                                                    label: 'reportTypeName',
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} >
                                        <Row>
                                            <Col className='required-date'>
                                                <FormGroup>
                                                    <Label></Label>
                                                    <Label
                                                        htmlFor="StartDate" for='reportname'
                                                        className={focusedInput === 'StartDate' ? 'label-focus' : ''}
                                                    >Start Date</Label>
                                                    <InputGroup onMouseLeave={handleMouseLeave}>
                                                        <DatePicker
                                                            id='startDate'
                                                            name='startDate'
                                                            selected={startDateValue}

                                                            onChange={(startDate) => handleStartDate(startDate)}
                                                            onFocus={() => handleFocus('StartDate')}
                                                            onBlur={handleBlur}
                                                            isClearable
                                                            onChangeRaw={handleStartDateRaw}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText='Select a date'
                                                            autoComplete='off'
                                                            customInput={
                                                                <ReactInputMask mask="99/99/9999"
                                                                    value={startDateValue}
                                                                // maskChar=''
                                                                />
                                                            }
                                                        />
                                                        <InputGroupText
                                                            onClick={() => handleDateClick('startDate')}
                                                        >
                                                            <img src={Calendar} alt='' />
                                                        </InputGroupText>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col xs='auto' className='pt-3 mt-3'>
                                                <Label className='mt-1'>-</Label>
                                            </Col>
                                            <Col>
                                                <FormGroup>
                                                    <Label></Label>
                                                    <Label
                                                        htmlFor="EndDate" for='reportname'
                                                        className={focusedInput === 'EndDate' ? 'label-focus' : ''}
                                                    >End Date</Label>
                                                    <InputGroup onMouseLeave={handleMouseLeave} className='required-date'>
                                                        <DatePicker
                                                            id='endDate'
                                                            name='endDate'
                                                            onFocus={() => handleFocus('EndDate')}
                                                            onBlur={handleBlur}
                                                            selected={endDateValue}
                                                            minDate={startDateValue}
                                                            onChange={handleEndDate}
                                                            onChangeRaw={handleEndDateRaw}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText='Select a date'
                                                            autoComplete='off'
                                                            customInput={
                                                                <ReactInputMask mask="99/99/9999"
                                                                    value={endDateValue}
                                                                // maskChar=''
                                                                />
                                                            }
                                                        />
                                                        <InputGroupText
                                                            onClick={() => handleDateClick('endDate')}
                                                        >
                                                            <img src={Calendar} alt='' />
                                                        </InputGroupText>
                                                    </InputGroup>
                                                    {(endDateError) && (startDateValue > endDateValue) ? <div className="text-danger f-12">
                                                        EndDate should be greater than StartDate or Null</div> : ''}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div className='section-devider-border mt-2 mb-3'></div>
                            <div hidden={""}>
                                <Row>
                                    <Col sm={0} className="d-flex" style={{ justifyContent: "flex-end" }}>
                                        <Label>{""}</Label>
                                        <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="reset"
                                            onClick={handleReset}
                                        // onClick={""}

                                        // disabled={!coveredEntityid}
                                        // hidden={!hasPermission("ADD")}
                                        >
                                            <span className='right_5'><img src={reset} alt="" /></span>
                                            Reset
                                        </Button>
                                        <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="search"
                                            onClick={handleSubmit}

                                        // disabled={!coveredEntityid}
                                        // hidden={!hasPermission("ADD")}
                                        >
                                            <span className='right_5'> <img src={search} alt="" /></span>
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    );
                }
                }>
            </Formik>
        </div>
    )
}

export default SearchContainer